// Универсальная функция валидации для всех форм
export function validateField(name, value, category) {
  switch (name) {
    case 'location':
      return !value?.address ? 'Укажите локацию' : '';
    case 'duties':
      // Для всех категорий теперь минимум 5 символов
      return !value || value.length < 5 ? 'Минимум 5 символов' : '';
    case 'schedule':
      if (!value) return 'Выберите график работы';
      switch (value.scheduleType) {
        case 'custom':
          if (!value.days?.length) return 'Выберите дни недели';
          if (!value.hours) return 'Укажите количество часов';
          return '';
        case '5_2':
        case '6_1':
          if (!value.hours) return 'Укажите количество часов';
          return '';
        case 'shift':
          if (!value.shiftDetails) return 'Укажите детали вахты';
          return '';
        default:
          return 'Выберите график работы';
      }
    case 'fullName':
    case 'name':
      return !value || value.length < 2 ? 'Укажите имя и фамилию' : '';
    case 'contacts':
      return !value ? 'Укажите контактные данные' : '';
    case 'childrenInfo':
      if (!value || value.length === 0) return 'Добавьте информацию о детях';
      return value.some(child => !child.age) ? 'Укажите возраст ребенка' : '';
    case 'houseInfo':
      if (!value) return 'Заполните информацию о помещении';
      if (!value.rooms) return 'Укажите количество комнат';
      if (!value.area) return 'Укажите площадь';
      if (!value.residents) return 'Укажите количество проживающих';
      return '';
    case 'birthDate':
      return !value ? 'Укажите дату рождения' : '';
    case 'citizenship':
      return !value ? 'Укажите гражданство' : '';
    case 'education':
      return !value ? 'Укажите уровень образования' : '';
    case 'languages':
      return !value ? 'Укажите языки и уровень владения' : '';
    case 'experience':
      return !value ? 'Опишите ваш опыт работы' : '';
    case 'skills':
      return !value ? 'Укажите ваши навыки' : '';
    case 'aboutMe':
      return !value ? 'Расскажите о себе' : '';
    case 'desiredSchedule':
      return !value ? 'Укажите желаемый график работы' : '';
    case 'desiredSalary':
      return !value ? 'Укажите желаемую оплату' : '';
    case 'startDate':
      // Не обязательное поле
      return '';
    default:
      return '';
  }
} 